import { Link } from 'react-router-dom'
import { MEALS, formatKcal } from '@/domain/health/nutrition'
import { useNutrition, useNutritionToday } from './useNutrition'

export function IntakeCard({ timeZone, referenceAt }: { timeZone: string; referenceAt?: string }) {
  const today = useNutritionToday(timeZone, referenceAt)
  const { data, error, reload } = useNutrition()
  const records = data?.records.filter((r) => r.localDay === today) ?? []
  return <section className="intake-card" aria-labelledby="intake-card-title">
    <div className="nutrition-heading"><div><p className="journal-eyebrow">好好吃饭，也好好记录</p><h2 id="intake-card-title">今日摄入</h2></div><Link to="/nutrition?add=1" className="nutrition-link">记一餐 <span aria-hidden="true">＋</span></Link></div>
    {error ? <p role="alert">饮食读取失败 <button type="button" onClick={reload}>重试</button></p>
      : !data ? <p role="status">正在读取…</p> : <>
      <p className="intake-card__value">{records.length ? <><strong>{formatKcal(records.reduce((sum, r) => sum + r.kcal, 0))}</strong><span>kcal</span></> : <strong className="intake-card__empty">未记录</strong>}</p>
      <div className="intake-card__meals">{MEALS.map((meal) => {
        const items = records.filter((r) => r.meal === meal.value)
        return <Link key={meal.value} to={`/nutrition?add=1&meal=${meal.value}`}><span>{meal.label}</span><b>{items.length ? formatKcal(items.reduce((sum, r) => sum + r.kcal, 0)) : '—'}</b></Link>
      })}</div></>}
  </section>
}
